export interface useRequest {
  loading: boolean;
  error: boolean;
  success: boolean;
}

export interface Action {
  type: "loading" | "error" | "success" | any;
  value?: any;
}

export const stateSwitch = (state: any, action: Action) => {
  switch (action.type) {
    case "loading":
      return {
        ...state,
        loading: action.value,
      };
    case "success":
      return {
        ...state,
        success: action.value,
      };
    case "error":
      return {
        ...state,
        error: action.value,
      };
    default:
      return state;
  }
};
